import { render, staticRenderFns } from "./TableKitchenSink.vue?vue&type=template&id=166f31c7"
import script from "./TableKitchenSink.vue?vue&type=script&lang=js"
export * from "./TableKitchenSink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports